import { Box, Theme, createStyles, makeStyles, useRouter } from '@forgeglobal/design-framework'
import { CampaignForm } from 'components/campaigns/CampaignForm'
import { CampaignHeader } from 'components/campaigns/CampaignHeader'
import React, { Fragment } from 'react'

const useStyles = makeStyles(({ spacing }: Theme) =>
  createStyles({
    container: {
      padding: spacing(2),
    },
  })
)

export const CampaignFormPage: React.FC = () => {
  const classes = useStyles()
  const { match } = useRouter<{ id: string }>()

  const campaignId = match.params.id

  return (
    <Fragment>
      <Box className={classes.container}>
        <CampaignHeader type="form" />
        <CampaignForm campaignId={campaignId} />
      </Box>
    </Fragment>
  )
}
